<template>
    <div class="modal is-active">
        <div class="modal-background" @click="close"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    {{ $t("soap-builder.title") }}
                </p>
                <button class="delete" @click="close"></button>
            </header>
            <section class="modal-card-body">
                <div class="field">
                    <label class="label">{{
                        $t("soap-builder.note-title")
                    }}</label>
                    <div class="control">
                        <input type="text" class="input" v-model="title" />
                    </div>
                </div>
                <div class="field">
                    <label class="label">{{
                        $t("soap-builder.subjective")
                    }}</label>
                    <div class="control">
                        <input type="text" class="input" v-model="subjective" />
                    </div>
                </div>
                <div class="field">
                    <label class="label">{{
                        $t("soap-builder.objective")
                    }}</label>
                    <div class="control">
                        <input type="text" class="input" v-model="objective" />
                    </div>
                </div>
                <div class="field">
                    <label class="label">{{
                        $t("soap-builder.analysis")
                    }}</label>
                    <div class="control">
                        <input type="text" class="input" v-model="analysis" />
                    </div>
                </div>
                <div class="field">
                    <label class="label">{{ $t("soap-builder.plan") }}</label>
                    <div class="control is-expanded">
                        <!-- <input type="text" class="input" v-model="plan" /> -->
                        <div class="select">
                            <select v-model="plan">
                                <option value="Registro CAU">
                                    Registro CAU
                                </option>
                                <option value="Otros">Otros...</option>
                            </select>
                        </div>
                    </div>
                </div>
            </section>
            <footer class="modal-card-foot">
                <button
                    class="button is-success"
                    :class="{ 'is-loading': saving }"
                    :disabled="emptyTitle"
                    @click="save"
                >
                    {{ $t("soap-builder.save") }}
                </button>
                <button class="button" @click="close">
                    {{ $t("soap-builder.cancel") }}
                </button>
            </footer>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { RepositoryFactory } from "@/services/api";
import { noteTypes } from "@/config/index.js";

export default {
    name: "soap-builder",
    props: {
        noteId: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            subjective: "",
            objective: "",
            analysis: "",
            plan: "",
            title: "",

            saving: false,
        };
    },
    mounted() {
        if (this.noteId !== null) {
            let note = this.getNote(this.noteId);
            this.subjective = note.subjective;
            this.objective = note.objective;
            this.analysis = note.analysis;
            this.plan = note.plan;
            this.title = note.title;
        } else {
            this.subjective = this.getConferenceName;
        }
    },
    computed: {
        ...mapGetters("notes", ["getNote"]),
        ...mapGetters("conference", ["getConferenceId", "getConferenceName"]),
        emptyTitle() {
            return this.title === "";
        },
    },
    methods: {
        ...mapActions("notes", ["addNote", "setNote"]),
        close() {
            this.$emit("close");
        },
        async save() {
            this.saving = true;
            if (this.noteId !== null) {
                // Update
                try {
                    let note = this.getNote(this.noteId);
                    note.subjective = this.subjective;
                    note.objective = this.objective;
                    note.analysis = this.analysis;
                    note.plan = this.plan;
                    note.title = this.title;

                    await RepositoryFactory.notes.updateNote({ note: note });

                    this.setNote(note);
                    this.close();
                } catch (error) {
                    window.console.log(error);
                }
            } else {
                // Save
                try {
                    let note = {
                        type: noteTypes.soap,
                        roomId: this.getConferenceId,
                        title: this.title,
                        subjective: this.subjective,
                        objective: this.objective,
                        analysis: this.analysis,
                        plan: this.plan,
                    };

                    let response = await RepositoryFactory.notes.addNote({
                        note: note,
                    });

                    note.id = response.data;
                    this.addNote(note);

                    this.close();
                } catch (error) {
                    window.console.log(error);
                }
            }
            this.saving = false;
        },
    },
};
</script>